import { getConfig } from "../../../config";
import { MessageEventBus } from "../../event-bus";

export class ErrorHandler {
  constructor(private action: string) {}

  handle(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: any,
    msgId?: string,
    defaultMsg = "Unknown Error",
    showError = true,
    abortMessage = "Loading got manually cancelled.",
    showAbort = true
  ) {
    let info = defaultMsg;
    let status = 0;
    if (e?.name === "CanceledError" || e?.name === "AbortError") {
      info = abortMessage;
      showError = showAbort;
    } else if (e?.response) {
      status = e.response.status;
      switch (e.response.status) {
        case 401:
          info = "Authentication failed.\n Please make sure you are logged in.";
          break;
        case 403:
          if (e.response.data?.requiredProducts) {
            const products = e.response.data?.requiredProducts.join(" or ");
            info = "Feature is only available in " + products + ".";
          }
          if (e.response.data?.expirationDate === 0) {
            info = "Subscription is inactive.";
          }
          if (e.response.data?.expirationDate > 0) {
            info = "Subscription is expired.";
          }
          if (e.response.data?.error === "MISSING_FEATURE") {
            info = "Required feature is not available";
          }
          break;
        case 501:
          info = "Not implemented";
          break;
        case 500:
        case 404:
          info = e.response.error || "Internal Server Error.";
          break;
      }
    } else if (e?.code === "ERR_NETWORK") {
      info = this.getInfoForERR_NETWORK();
    }
    if (showError) {
      MessageEventBus.emit("error", {
        text: info,
        id: msgId || this.action,
        status: status,
      });
    }

    return info;
  }

  private getInfoForERR_NETWORK() {
    const config = getConfig();
    if (config.backendURL === import.meta.env.VUE_APP_BACKEND_URL) {
      return "Please check your internet connection or try again later as our platform might currently not be reachable.";
    }
    return "Unable to connect to server.";
  }
}
